<template>
    <div>
        <b-card no-body class="border mt-1">
            <b-card-header class="p-1">
              <b-card-title class="font-medium-2">
                <span >{{  $t('Law Matter Sub Subject')  }}</span>
              </b-card-title>
            </b-card-header>
            <!--eslint-disable-->
            <div class="table-container">
              <table class="table table-striped table-bordered" >
                <tbody>
                   <tr v-for="(group, index) in groupedSubSubjects" :key="index">
                      <td v-for="ssl in group" :key="ssl.id">
                        <b-form-checkbox :checked="ssl.selected" @change="changeSubSubjectRelation($event, ssl.id)" /> {{ ssl.name }}                                               
                     </td>
                   </tr>
                </tbody>
              </table>
           </div>

          </b-card>
    </div>
</template>
<script>
export default{
  data(){
    return {
        lawMatterSubSubjectTableList:[]
    }
    
  },
  props:{
    subjectId:{
        type: Number,
        required: true
    }
  },
  methods:{
    async showLawMatterSubSubjects() {
     
      const controller = { name: 'LawMatterSubSubject'}
      const payload = {controller: controller }
      const response = await this.$store.dispatch('moduleAuth/getList', payload)
        if (response.data.resultStatus == true) {
          this.lawMatterSubSubjectTableList = response.data.lawMatterSubSubjectList
          
        } else {
          this.$WarningAlert(response.data.resultMessage)
        }
     
    },
    async changeSubSubjectRelation(selected, subSubjectId) {
      let response = null
      let controller = { name: 'LawMatterSubjectRelation' }
      const data = { lawMatterSubSubjectId: subSubjectId,lawMatterSubjectId : this.subjectId}
      if (selected == true) {
          const payload = { data: data, controller: controller }
          response =  await this.$store.dispatch('moduleAuth/save', payload)
          if (response.data.resultStatus == true) {
            this.$SaveAlert()
          } else {
            this.$WarningAlert(response.data.resultMessage)
          }
      }
      else {
        controller = { name: 'LawMatterSubjectRelation',actionName:'DeleteLawMatterSubjectRelationWithParent'}
        const payload = { data: data, controller: controller}
        response = await  this.$store.dispatch('moduleAuth/customService', payload)
          if (response.data.resultStatus == true) {
            this.$SaveAlert()
          } else {
            this.$WarningAlert(response.data.resultMessage)
          }
      }
    },
  },
  computed:{
    groupedSubSubjects() {
      const groups = [];
      for (let i = 0; i < this.lawMatterSubSubjectTableList.length; i += 3) {
        groups.push(this.lawMatterSubSubjectTableList.slice(i, i + 3));
      }
      return groups;
    }
  }
}
</script>
<style>
 .tab-content > .active {
  display: block;
  width: 30em;
} 
.table-container {
  /* max-height: 100px; */
   display: block;
   height: auto; 
}

</style>